import { __read } from 'tslib';
import React__default, { useState, useRef, useMemo, useEffect } from 'react';
import { useNvModal, NvMarkdownInline, NvHeading, NvModal } from '@invitae/ids-react';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import styles from './TeamGroup.module.esm.js';

var TeamGroup = function (_a) {
    var heading = _a.heading, items = _a.items;
    var _b = __read(useState(undefined), 2), selectedTeamMember = _b[0], setSelectedMember = _b[1];
    var ref = useRef(null);
    var _c = useNvModal(ref), openModalDialog = _c.openModalDialog, closeModalDialog = _c.closeModalDialog;
    var teamMember = useMemo(function () {
        if (items.length && selectedTeamMember !== undefined && items[selectedTeamMember]) {
            return items[selectedTeamMember].fields;
        }
        return undefined;
    }, [selectedTeamMember, items]);
    var onDismissModal = function () {
        setSelectedMember(undefined);
    };
    useEffect(function () {
        var _a;
        if (selectedTeamMember !== undefined && !((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.open)) {
            openModalDialog();
        }
    }, [openModalDialog, selectedTeamMember]);
    return (React__default.createElement("div", { className: styles.wrapper },
        heading && (React__default.createElement(NvMarkdownInline, { className: styles.title, elementWrapper: NvHeading, level: 4, theme: "deepTeal" }, heading)),
        React__default.createElement("div", { className: styles.list }, items.map(function (_a, index) {
            var _b = _a.fields, name = _b.name, image = _b.image, title = _b.title, sys = _a.sys;
            return (React__default.createElement("div", { className: styles.listItem, "data-testid": "team-member-".concat(index), key: sys.id, onClick: function () { return setSelectedMember(index); } },
                React__default.createElement("div", { className: styles.wrapperImage },
                    React__default.createElement(BaseNucleobaseComponent, { maxImageWidth: 375, source: image })),
                React__default.createElement("div", { className: styles.wrapperTitle },
                    React__default.createElement("p", null, name),
                    React__default.createElement("p", null, title))));
        })),
        React__default.createElement(NvModal, { onDismiss: onDismissModal, onPrimaryButtonClicked: closeModalDialog, primaryButtonText: "Close", ref: ref, showCloseButton: true }, teamMember && (React__default.createElement("div", { className: styles.wrapperModal },
            React__default.createElement(BaseNucleobaseComponent, { maxImageWidth: 375, source: teamMember.image }),
            React__default.createElement("div", { className: styles.modalText },
                React__default.createElement("div", { className: styles.modalHeader },
                    React__default.createElement(NvHeading, { level: 3 }, teamMember.name),
                    React__default.createElement("p", null, teamMember.title)),
                React__default.createElement("p", null, teamMember.bio)))))));
};

export { TeamGroup as default };
//# sourceMappingURL=TeamGroup.esm.js.map
